module.exports = __webpack_public_path__ + "img/Up_dejun.52bb146e.jpg";